// src/Contact.jsx
import React from "react";

export default function Contact() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Contact Us</h1>

      <p className="mb-4">
        We value your questions, feedback, and suggestions. Whether you’re a subscriber, a potential partner,
        or just curious about PlaysWithGuru, we’re here to help.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Email Support</h2>
      <p className="mb-4">
        📧{" "}
        <a
          href="mailto:playswithguru@gmail.com"
          className="text-blue-600 underline"
        >
          playswithguru@gmail.com
        </a>
      </p>
      <p className="mb-6">
        We typically respond within <strong>1–2 business days</strong>.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Business Inquiries</h2>
      <p>
        For business partnerships, media requests, or collaboration opportunities, please email us
        with “Business Inquiry” in the subject line.
      </p>
    </div>
  );
}
